// extracted by mini-css-extract-plugin
module.exports = {"mobileResults":"mobile-results_mobileResults__d6Sa_"};